var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t("personalInformations")))]),_vm._v(" "),(_vm.clientType != 1)?_c("company-informations",{tag:"div"}):_vm._e(),_vm._v(" "),(_vm.clientType === 1)?_c("personal-informations",{tag:"div"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }